module.exports = __webpack_public_path__ + "img/MotionGraphics.9bfb2e38.jpg";